import { useCustomQuery } from "hooks/useCustomQuery"
import { AdCampaignsService } from "services/api-service"
import { AdSystemSettings } from "services/api-service/types"

export const useAdSystems = () =>
  useCustomQuery<AdSystemSettings[]>({ key: ["adSystems"] }, () => AdCampaignsService.getSystems())
